<!--
 * @Date: 2022-09-13 19:19:03
 * @LastEditTime: 2023-01-13 18:42:28
 * @Description: 青心计划 金币活动页
-->
<template>
  <div class="qingxin-task">
    <img
      src="https://resource.chunyu.mobi/@/media/images/2023/01/13/8626/1814234b0931_w1125_h1332_.jpg"
      alt=""
      class="bg"
    />
    <!-- 个人金币信息 -->
    <div class="personal-act-info" @click="toGoldenPage">
      <img :src="activityInfo.avatar" alt="" class="avatar" />
      <div>
        <div class="icon all-icon">
          <span class="icon-desc">全部金币</span>
          <span class="icon-number">{{ activityInfo.total_gold_num }}</span>
        </div>
        <div class="icon act-icon">
          <span class="icon-desc">活动金币</span>
          <span class="icon-number">{{ activityInfo.activity_gold_num }}</span>
        </div>
      </div>
    </div>
    <!-- 兑换奖励 -->
    <img
      src="https://resource.chunyu.mobi/@/media/images/2022/09/19/5523/b2f8af0759bc_w240_h240_.png"
      class="get-icon left"
      @click="toGet"
    />
    <!-- 抽奖转盘 -->
    <img
      src="https://resource.chunyu.mobi/@/media/images/2023/01/13/6b63/c8d34fcb3025_w216_h216_.gif"
      class="get-icon right"
      @click="toLottery"
    />
    <!-- 活动规则 -->
    <ActivityRule :url="activityInfo.rules_url" />
    <!-- 运营位 -->
    <img
      :src="activityInfo.operate_img"
      alt=""
      class="operate"
      @click="handleJumpOperate(activityInfo.operate_jump_url)"
    />
    <!-- 任务列表 -->
    <div class="task">
      <div class="task-top">
        <img :src="taskInfo.title" alt="" class="taskTitle" />
      </div>
      <div class="task-list-wrapper">
        <div
          v-for="item in taskInfo.task_list"
          :key="item.id"
          class="task-list-item"
        >
          <div class="task-info">
            <div class="topinfo">
              <span class="task-name">{{ item.name }}</span>
              <span class="times"
                >({{ item.finished_times }}/{{ item.total_times }})</span
              >
              <img
                src="https://resource.chunyu.mobi/@/media/images/2022/09/19/8bab/130c08d4a53a_w42_h42_.png"
                alt=""
                class="gold-icon"
              />
              <span class="gold-num">+{{ item.gold_num }}</span>
            </div>
            <div class="desc">
              {{ item.desc }}
            </div>
          </div>
          <div
            :class="
              item.finished_times === item.total_times
                ? 'finished-task task-button'
                : 'task-button'
            "
            @click="doTask(item)"
          >
            {{ item.btn_text }}
          </div>
        </div>
      </div>
    </div>
    <!-- 排名 -->
    <div
      v-if="activityInfo.rank_list && activityInfo.rank_list.length"
      class="rank"
    >
      <div class="rank-title">
        <img
          src="https://staff.chunyu.mobi/@/media/images/2022/11/14/53ca/ac9601ba9710_w47_h55_.png"
        />
        <span>活动金币每日排行榜</span>
        <img
          src="https://staff.chunyu.mobi/@/media/images/2022/11/14/53ca/ac9601ba9710_w47_h55_.png"
        />
      </div>
      <div class="rank-list-wrapper">
        <ul class="rlw-title">
          <li>排名</li>
          <li>用户ID</li>
          <li>累计活动金币</li>
        </ul>
        <div
          v-for="(item, index) in activityInfo.rank_list"
          :key="index"
          class="rank-list-item"
        >
          <div class="rank-info">
            <div class="ranks">
              <img v-if="index < 3" :src="rankImg[index + 1]" alt="" />
              <span v-else>{{ index + 1 }}</span>
            </div>
          </div>
          <div class="rank-id">
            <img :src="item.image" alt="" />
            <span>{{ item.nickname }}</span>
          </div>
          <div class="rank-icon">
            {{ item.gold_coin }}
            <img
              src="https://staff.chunyu.mobi/@/media/images/2022/11/14/8fe6/be3efaf7cbc4_w41_h42_.png"
            />
          </div>
        </div>
      </div>
      <div class="rank-tips">
        *累计活动金币:通过活动赚取的金币数量,金币消耗不计算在内
      </div>
    </div>
    <!-- 活动奖品 -->
    <div v-if="activityInfo.prize_url" class="prize">
      <img :src="activityInfo.prize_url" alt="" />
    </div>
    <!-- toast -->
    <div v-if="showToast" class="toast">
      <span class="tiptext">{{ toast.toast_text }}</span>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/09/19/8bab/130c08d4a53a_w42_h42_.png"
        alt=""
        class="gold-icon"
      />
      <span class="icon-num">+{{ toast.gold_num }}</span>
    </div>
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import {
  getQinxinTaskTopInfo,
  getQinxinTaskList,
  isLogin,
} from '@/services/index';
import { doPoint, requestEvent } from '@/utils/index';
import ActivityRule from './components/ActivityRule.vue';

export default {
  components: {
    ActivityRule,
  },
  data() {
    return {
      activityInfo: {}, // 头部信息
      taskInfo: {
        toast_list: [],
      }, // 任务信息
      toast: {}, // 当前toast
      showToast: false, // 是否展示toast
      activity_id: '', // 活动id
      timer: '', // toastTimer
      rankImg: {
        1: 'https://staff.chunyu.mobi/@/media/images/2022/11/14/1375/6c67ee21c77d_w66_h60_.png',
        2: 'https://staff.chunyu.mobi/@/media/images/2022/11/14/d57d/cab830f82607_w64_h60_.png',
        3: 'https://staff.chunyu.mobi/@/media/images/2022/11/14/748f/8b00e59cff7b_w64_h60_.png',
      },
    };
  },
  mounted() {
    console.log('1.1');
    isLogin().then(res => {
      const { is_login } = res;
      if (!is_login) {
        // 登录路由跳转
        requestEvent();
      } else {
        const { gold_activity_id } = this.$route.query;
        this.activity_id = gold_activity_id;
        window.addEventListener('pageshow', () => {
          this.getData();
          // iphoneX 尝试规避缓存
          setTimeout(() => {
            this.getData();
          }, 1000);
          this.onShare();
        });
        this.getData();
        this.onShare();
      }
    });
  },
  methods: {
    /**
     * 页面数据获取
     */
    getData() {
      Promise.all([
        getQinxinTaskTopInfo({
          activity_id: this.activity_id,
        }),
        getQinxinTaskList({
          activity_id: this.activity_id,
        }),
      ]).then(resp => {
        this.activityInfo = resp[0].data;
        this.taskInfo = resp[1].data;
        this.$forceUpdate();
        // if (this.taskInfo.toast_list.length) {
        //   this.pollingShowToast();
        // }
      });
    },
    /**
     * 做任务
     *
     * @param data 任务链接
     */
    doTask(data) {
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '去完成任务',
        click_position_value: data.name,
      });
      window.location.href = data.jump_url;
    },
    /**
     * 去抽奖
     */
    toLottery() {
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '抽奖',
      });
      window.location.href = this.activityInfo.lottery_url;
    },
    /**
     * 金币页
     */
    toGoldenPage() {
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '我的金币',
      });
      const url = `${window.location.origin}/api/gold/homepage/`;
      window.location.href = url;
    },
    /**
     * 兑换奖励
     */
    toGet() {
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '兑换奖励',
      });
      const url = `${window.location.origin}/api/gold/coupon/list/#OPEN_NEW_WIN`;
      window.location.href = url;
    },
    /**
     * toast轮播
     */
    pollingShowToast() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      let index = 0;
      this.toast = this.taskInfo.toast_list[index];
      this.handleShowToast();
      this.timer = setInterval(() => {
        index += 1;
        if (index <= this.taskInfo.toast_list.length - 1) {
          this.toast = this.taskInfo.toast_list[index];
          this.handleShowToast();
        } else {
          clearInterval(this.timer);
        }
      }, 2000);
    },
    /**
     * 控制toast展示隐藏
     */
    handleShowToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
    /**
     * 禁止该页面分享
     */
    onShare() {
      const params = {
        title: '做任务赢金币', // 标题
        desc: '价值400元SKG颈椎按摩仪免费拿', // 描述
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/09/27/8c12/9d759cced3f8_w2250_h1800_.png',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/09/27/8c12/9d759cced3f8_w2250_h1800_.png', // 分享的图片展示
        link: window.location.href,
        page_title: '做任务赢金币',
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        need_invitate_id: false,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      if (cyDetect.isFromWechat()) {
        cyShare.weixin({
          img:
            'https://resource.chunyu.mobi/@/media/images/2022/09/27/8c12/9d759cced3f8_w2250_h1800_.png',
          title: '做任务赢金币', // 标题
          desc: '价值400元SKG颈椎按摩仪免费拿', // 描述
          link: window.location.href,
        });
      } else {
        cyShare.app(params);
      }
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
    // 运营位调整
    handleJumpOperate(url) {
      this.doPagePoint('AppClick', {
        page_readable_name: '运营活动',
        page_title: '金币任务页',
        click_position: '横幅运营位',
      });
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.qingxin-task {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #fed8c5;
  .bg {
    display: block;
    width: 100vw;
  }
  .personal-act-info {
    position: absolute;
    top: rem(313);
    left: 50%;
    display: flex;
    align-items: center;
    transform: translateX(-50%);
    .icon {
      color: #fef1d1;
      font-size: 18px;
      .icon-desc {
        margin-right: rem(3);
        margin-bottom: rem(1);
        font-size: 12px;
        vertical-align: middle;
      }
      .icon-number {
        font-weight: bold;
        vertical-align: middle;
      }
    }
    .avatar {
      width: rem(36);
      height: rem(36);
      margin-right: rem(6);
      object-fit: contain;
      border-radius: 50%;
    }
  }
  .task {
    width: rem(345);
    margin: 0 auto rem(25) auto;
    background: #fff;
    border-radius: rem(4);
    .taskTitle {
      width: 100%;
    }
    .task-top {
      height: rem(55);
      color: #fff;
      font-weight: bold;
      font-size: rem(23);
      line-height: rem(55);
      text-align: center;
      background-image: linear-gradient(90deg, #ff3636 0%, #ff756d 100%);
      border-top-left-radius: rem(5);
      border-top-right-radius: rem(5);
    }
    .task-list-wrapper {
      box-sizing: border-box;
      padding: rem(10);
      .task-list-item {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        width: rem(321);
        height: rem(62);
        margin-bottom: rem(10);
        padding: rem(12) rem(10) rem(12) rem(8);
        background: #fff3eb;
        border-radius: rem(10);
        .topinfo {
          display: flex;
          align-items: center;
          color: #5b1d00;
          font-size: rem(14);
          .task-name {
            font-weight: bold;
          }
          .times {
            margin-left: 0.5em;
            font-weight: bold;
          }
          .gold-num {
            color: #ff4d52;
            font-size: rem(14);
          }
        }
        .desc {
          margin-top: rem(8);
          color: #ac7c68;
          font-size: rem(12);
        }
        .task-button {
          width: rem(75);
          height: rem(34);
          color: #fff;
          font-weight: bold;
          font-size: rem(14);
          line-height: rem(34);
          text-align: center;
          background-image: linear-gradient(180deg, #fe7552 0%, #ff4043 100%);
          border-radius: rem(17);
        }
        .finished-task {
          background: #ffa29b;
        }
      }
    }
  }

  .rank {
    width: rem(345);
    margin: 0 auto rem(25) auto;
    padding: 0 0 rem(11) 0;
    background: #fff;
    border-radius: rem(4);
    .rank-title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: rem(55);
      color: #fff;
      font-weight: bold;
      font-size: rem(23);
      line-height: rem(55);
      text-align: center;
      background-image: linear-gradient(90deg, #ff3636 0%, #ff756d 100%);
      border-top-left-radius: rem(5);
      border-top-right-radius: rem(5);
      span {
        padding: 0 rem(8);
      }
      img {
        width: rem(17);
        height: rem(20);
      }
    }
    .rank-list-wrapper {
      .rlw-title {
        display: flex;
        padding: rem(5) rem(6) rem(7);
        color: #ac7c68;
        font-size: rem(12);
        line-height: rem(24);
        li {
          &:nth-child(1) {
            margin-right: rem(50);
          }
          &:last-child {
            margin-left: auto;
          }
        }
      }

      box-sizing: border-box;
      padding: 0 rem(10);
      .rank-list-item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: rem(321);
        margin-bottom: rem(10);
        padding: rem(8) rem(18) rem(12) rem(12);
        color: #5b1d00;
        font-size: rem(14);
        background: #fff3eb;
        border-radius: rem(10);
        .ranks {
          width: rem(21);
          text-align: center;
          img {
            width: rem(21);
            height: rem(20);
          }
        }
        .rank-id {
          display: flex;
          align-items: center;
          margin-left: rem(17);

          img {
            width: rem(34);
            height: rem(34);
            margin-right: rem(10);
          }
          span {
            max-width: rem(145);
            @include multiple-ellipsis(2);
          }
        }
        .rank-icon {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          margin-left: auto;
          color: #ff4d52;
          img {
            width: rem(14);
            height: rem(14);
            margin-left: rem(3);
          }
        }
      }
    }
    .rank-tips {
      margin-top: rem(13);
      color: #ac7c68;
      font-size: rem(10);
      text-align: center;
    }
  }

  .prize {
    width: rem(345);
    margin: 0 auto rem(25) auto;
    img {
      width: rem(345);
    }
  }

  .get-icon {
    position: absolute;
    top: rem(348);
    width: rem(80);
    height: rem(80);
  }
  .left {
    left: 0;
  }
  .right {
    right: 0;
  }
  .toast {
    position: fixed;
    bottom: rem(70);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: rem(46);
    color: #fff;
    font-size: rem(14);
    line-height: rem(46);
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: rem(4);
  }
  .gold-icon {
    width: rem(14);
    height: rem(14);
    margin: 0 rem(2) 0 rem(12);
  }

  .operate {
    display: block;
    width: 100%;
  }
}
</style>
